(() => {
  const blockSelector = '[data-dio-preorder-availability]';
  const millisecondsPerDay = 24 * 60 * 60 * 1000;

  const parseIsoDate = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(Date.UTC(year, month - 1, day));

    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
      return null;
    }

    return date.getTime();
  };

  const initBlock = (block) => {
    if (block.dataset.dioPreorderReady === 'true') return;
    block.dataset.dioPreorderReady = 'true';

    const estimateRow = block.querySelector('[data-dio-preorder-estimate-row]');
    const estimate = block.querySelector('[data-dio-preorder-estimate]');
    const shipDate = parseIsoDate(block.dataset.shipDate || '');
    if (!estimateRow || !estimate || shipDate === null) return;

    const now = new Date();
    const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const remainingDays = Math.ceil((shipDate - today) / millisecondsPerDay);

    if (remainingDays <= 0) {
      const fallbackText = block.dataset.fallbackText?.trim();
      if (!fallbackText) return;
      estimate.textContent = fallbackText;
    } else {
      const weeks = Math.ceil(remainingDays / 7);
      estimate.textContent = weeks === 1 ? 'Approximately 1 week' : `Approximately ${weeks} weeks`;
    }

    estimateRow.hidden = false;
  };

  const init = (root = document) => {
    if (root.matches?.(blockSelector)) initBlock(root);
    root.querySelectorAll?.(blockSelector).forEach(initBlock);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
